import { useGlobalState } from "@/hooks";
import closeIcon from "/images/close-icon.svg";

export const ReconnectPrompt = () => {
  const { reconnect, setShowReconnectPrompt } = useGlobalState();
  const handleReconnect = () => {
    reconnect({
      newRoom: true,
    });

    setShowReconnectPrompt(false);
  };
  const handleClose = () => {
    setShowReconnectPrompt(false);
  };

  return (
    <div className="nut-flex nut-items-center nut-mt-4 nut-p-4 nut-rounded-xl nut-bg-gray-100 nut-text-gray-800 nut-overflow-visible nut-relative">
      <a
        onClick={handleClose}
        className="nut-absolute nut-top-1 nut-right-1 nut-w-[20px] nut-cursor-pointer nut-h-[20px] nut-rounded-[50%] nut-flex nut-items-center nut-justify-center"
      >
        <img
          src={closeIcon}
          alt="close-icon"
          className="nut-w-[8px] nut-h-[8px]"
        />
      </a>
      Looks like I went quiet for a second — mind if we reconnect?
      <button
        className="cursor-pointer voice-chat_button nut-inline-block nut-w-fit nut-text-center nut-py-4 nut-px-6 nut-rounded-[1022px] nut-text-white nut-ml-2"
        onClick={handleReconnect}
      >
        Reconnect
      </button>
    </div>
  );
};
